export default __webpack_public_path__ + "static/realWorldImg4-6dcc6a190cf7e6f9dac3a8faec9bc06c.webp";